/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Jump_NowInputs */

const en_btn_jump_now = /** @type {(inputs: Btn_Jump_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spend`)
};

const ar_btn_jump_now = /** @type {(inputs: Btn_Jump_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنفق`)
};

const de_btn_jump_now = /** @type {(inputs: Btn_Jump_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgeben`)
};

const es_btn_jump_now = /** @type {(inputs: Btn_Jump_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gastar`)
};

const fr_btn_jump_now = /** @type {(inputs: Btn_Jump_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dépenser`)
};

const it_btn_jump_now = /** @type {(inputs: Btn_Jump_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spendi`)
};

const ja_btn_jump_now = /** @type {(inputs: Btn_Jump_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消費`)
};

const ko_btn_jump_now = /** @type {(inputs: Btn_Jump_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용`)
};

const pt_br_btn_jump_now = /** @type {(inputs: Btn_Jump_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gastar`)
};

const ru_btn_jump_now = /** @type {(inputs: Btn_Jump_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Потратить`)
};

const th_btn_jump_now = /** @type {(inputs: Btn_Jump_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใช้`)
};

const tr_btn_jump_now = /** @type {(inputs: Btn_Jump_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harca`)
};

const zh_cn_btn_jump_now = /** @type {(inputs: Btn_Jump_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`花费`)
};

const zh_tw_btn_jump_now = /** @type {(inputs: Btn_Jump_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`花費`)
};

/**
* | output |
* | --- |
* | "Spend" |
*
* @param {Btn_Jump_NowInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_jump_now = /** @type {((inputs?: Btn_Jump_NowInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Jump_NowInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_jump_now(inputs)
	if (locale === "ar") return ar_btn_jump_now(inputs)
	if (locale === "de") return de_btn_jump_now(inputs)
	if (locale === "es") return es_btn_jump_now(inputs)
	if (locale === "fr") return fr_btn_jump_now(inputs)
	if (locale === "it") return it_btn_jump_now(inputs)
	if (locale === "ja") return ja_btn_jump_now(inputs)
	if (locale === "ko") return ko_btn_jump_now(inputs)
	if (locale === "pt_br") return pt_br_btn_jump_now(inputs)
	if (locale === "ru") return ru_btn_jump_now(inputs)
	if (locale === "th") return th_btn_jump_now(inputs)
	if (locale === "tr") return tr_btn_jump_now(inputs)
	if (locale === "zh_cn") return zh_cn_btn_jump_now(inputs)
	return zh_tw_btn_jump_now(inputs)
});